import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import CryptoJS from "crypto-js";
import { jwtDecode } from 'jwt-decode';
import MetabolicSyndromeCalc from '../CalculatorCodes/MetabolicCode'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import restrictions from "../../../JSONS/calculator_res.json"

const MetabolicSyndromeCalculator = () => {

    const Navigate = useNavigate();
    const MySwal = withReactContent(Swal)

    const [validation, setvalidation] = useState({
      "Abs": "valid",
      "Trigli": "valid",
      "HDL": "valid",
      "Systolic": "valid",
      "Diastolic": "valid",
      "Glucose": "valid",
    });

    const [Abs,setAbs] = useState("")
    const [PastAbs,setPastAbs] = useState(false)
    const [Trigli,setTrigli] = useState("")
    const [PastTrigli,setPastTrigli] = useState(false)
    const [HDL,setHDL] = useState("")
    const [PastHDL,setPastHDL] = useState(false)
    const [Systolic,setSystolic] = useState("")
    const [PastSystolic,setPastSystolic] = useState(false)
    const [Diastolic,setDiastolic] = useState("")
    const [PastDiastolic,setPastDiastolic] = useState(false)
    const [Glucose,setGlucose] = useState("")
    const [PastGlucose,setPastGlucose] = useState(false)

    const [Calculated,setCalculated] = useState("")
    const [OneTime, setOneTime] = useState(0)
    const [PageStart, setPageStart] = useState(true)
    const [TaskDone, setTaskDone] = useState(false)
    const [FirstPage, setFirstPage] = useState(true)
    const [PagewidthCorrection, setPagewidthCorrection] = useState(window.innerWidth > 450 ? false : true);

    const [Risk, setRisk] = useState(0)

    const Token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : null;
    const decodedToken = Token ? jwtDecode(CryptoJS.AES.decrypt(Token, process.env.REACT_APP_TOKEN_ENC,{ mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }).toString(CryptoJS.enc.Utf8)) : null;
    const opening = decodedToken && decodedToken.health_report === false && window.localStorage.getItem("HabitsCalculated") ? JSON.parse(window.localStorage.getItem("HabitsCalculated")) : decodedToken ? decodedToken.health_report : false

    const Gender = decodedToken ? parseInt(decodedToken.gender) : null;

    const DoB = decodedToken ? new Date(decodedToken.born) : null;
    const DoBMonth = DoB ? DoB.getMonth() + 1 : 0
    const DoBDay = DoB ? DoB.getDate() : 0

    function AgeCalc() {
        const currentDate = new Date();
    
        const age = currentDate.getFullYear() - DoB.getFullYear();
        const currentMonth = currentDate.getMonth()+1;
        const currentDay = currentDate.getDate();
    
        if (age > 18) {
          if (currentMonth > DoBMonth || (currentMonth === DoBMonth && currentDay >= DoBDay)) {
            return age;
          } else {
            return age-1;
          }
        } else if (age === 18) {
    
          if (currentMonth > DoBMonth || (currentMonth === DoBMonth && currentDay >= DoBDay)) {
            return age;
          }
        }
    
        return false;
    }
    const Age = DoB ? AgeCalc() : 0

    
    useEffect(() => {
      if(!opening || Age > restrictions["met_syndrome"].max_age) {
        window.scrollTo(0, 0);
        Navigate("/perfil-de-usuario/calculadora-de-salud")
      }
    }, [opening, Navigate, Age]);

    const handleChange = (value, setValue) => {
      const result = value.replace(/\D/g, '');
      setValue(result.slice(0, 3));
    };

    function HandleSubmit() {
        let isAbsValid = Abs.trim() === "" ? "invalid" : Abs < 30 ? "invalid" : Abs > 300 ? "invalid" : "valid";
        let isTrigliValid = Trigli.trim() === "" ? "invalid" : "valid";
        let isHDLValid = HDL.trim() === "" ? HDL < 10 ? "invalid" : HDL > 120 ? "invalid" : "invalid" : "valid";
        let isSystolicValid = Systolic.trim() === "" ? "invalid" : Systolic < 40 ? "invalid" : Systolic > 370 ? "invalid" : "valid";
        let isDiastolicValid = Diastolic.trim() === "" ? "invalid" : Diastolic < 20 ? "invalid" : Diastolic > 360 ? "invalid" : "valid";
        let isGlucoseValid = Glucose.trim() === "" ? "invalid" : Glucose > 500 ? "invalid"  : "valid";

        setvalidation({
            "Abs": isAbsValid,
            "Trigli": isTrigliValid,
            "HDL": isHDLValid,
            "Systolic": isSystolicValid,
            "Diastolic": isDiastolicValid,
            "Glucose": isGlucoseValid,
        });
        let answers = [isAbsValid,isTrigliValid,isHDLValid,isSystolicValid,isDiastolicValid,isGlucoseValid]
    
        if(!answers.includes("invalid")) {
            getMetabolicRisk()
        }
    }

    function toggleAdditional(id) {
      let tmp = document.getElementById(id)
      if(tmp.className.includes("InformationCollapsed")) {
          tmp.className = tmp.className.replace(" InformationCollapsed", "");
      } else {
          tmp.className += " InformationCollapsed"
      }
    }

    async function getMetabolicRisk() {
      let gender = Gender === 1 ? "M" : "F"
      let res = await MetabolicSyndromeCalc(gender, Abs, Trigli, HDL, Systolic, Diastolic, Glucose)
      setRisk(res)

      uploadMetabolic(res)
    }

    const requestGetPatient = useCallback(async() => {
      if(!decodedToken) return

      MySwal.fire({
        position: "center",
        html: 
        <div className="FullAlertWidth1">
          <div className="FullAlertUpTitle">Cargando información de perfil...</div>
          <img alt="" className="FullAlertImageGif" src="https://static.yomecontrolo.cl/public/icons/ymc-loading.gif"/>
        </div>,
        color: "#340066",
        customClass: 'swal-wide',
        showConfirmButton: false,
        width: "100%",
      })

      let parameters2 = {
        rut: decodedToken.rut,
        within: [1,3,18,53,54,56]
      }
  
      let requestOptions2 = {
        method: 'POST',
        redirect: 'follow',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(parameters2)
      };
  
      try{

        let hasParams = true
        let resp2 = await fetch("https://ymc-graph-api.azurewebsites.net/getuserparams", requestOptions2)
        if (resp2.status !== 200){
            if(resp2.status !== 500) {
            MySwal.fire({
                icon: "error",
                title: "Ocurrió un error al subir los datos",
                text: "Por favor inténtelo más tarde",
                showConfirmButton: true
            });
            return false;
            } else {
            hasParams = false
            }
        }
        let data2 = await resp2.json();
        
        if(hasParams) {
            if(data2.params["56"]) {
                setAbs(data2.params["56"][1])
                setPastAbs(true)
            }
            if(data2.params["1"]) {
                setTrigli(data2.params["1"][1])
                setPastTrigli(true)
            }
            if(data2.params["3"]) {
                setHDL(data2.params["3"][1])
                setPastHDL(true)
            }
            if(data2.params["53"]) {
                setSystolic(data2.params["53"][1])
                setPastSystolic(true)
            }
            if(data2.params["54"]) {
                setDiastolic(data2.params["54"][1])
                setPastDiastolic(true)
            }
            if(data2.params["18"]) {
                setGlucose(data2.params["18"][1])
                setPastGlucose(true)
            }
        }

        MySwal.close();
        setTaskDone(true);
      }
      catch(error){
          MySwal.fire({
            icon: "error",
            title: "Ocurrió un error al subir los datos",
            text: "Por favor inténtelo más tarde",
            showConfirmButton: true
          });
          return false;
      }
    },[MySwal,decodedToken]);

    const uploadMetabolic = async(res) => {

      MySwal.fire({
        position: "center",
        html: 
        <div className="FullAlertWidth1">
          <div className="FullAlertUpTitle">Calculando...</div>
          <img alt="" className="FullAlertImageGif" src="https://static.yomecontrolo.cl/public/icons/ymc-loading.gif"/>
        </div>,
        color: "#340066",
        customClass: 'swal-wide',
        showConfirmButton: false,
        width: "100%",
      })
  
      let params = {
          rut: decodedToken.rut,
          gender: Gender,
          abs: Abs,
          trigli: Trigli,
          hdl: HDL,
          sistolic: Systolic,
          diastolic: Diastolic,
          glucose: Glucose,
          metabolic_points: res["points"],
          metabolic_risk: res["risk"],
      };

      let finalParamids = [
        !PastAbs ? 56 : false,
        !PastTrigli ? 1 : false,
        !PastHDL ? 3 : false,
        !PastSystolic ? 53 : false,
        !PastDiastolic ? 54 : false,
        !PastGlucose ? 18 : false
      ].filter(med => med !== false);
      let finalResults = [
        !PastAbs ? Abs : false,
        !PastTrigli ? Trigli : false,
        !PastHDL ? HDL : false,
        !PastSystolic ? Systolic : false,
        !PastDiastolic ? Diastolic : false,
        !PastGlucose ? Glucose : false
      ].filter(med => med !== false);

      let Dated = new Date()
  
      let params2 = {
        rut: decodedToken.rut,
        sex: Gender === 1 ? "M" : "F",
        ans: finalResults,
        ids: finalParamids,
        sindMet: res["risk"],
        date: Dated
      }
    
      let requestOptions = {
        method: 'POST',
        redirect: 'follow',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params)
      };

      let requestOptions2 = {
        method: 'POST',
        redirect: 'follow',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(params2)
      };
  
      try{
        
        const resp = await fetch("https://ymc-doc-api.azurewebsites.net/usermetabolics", requestOptions)
        if (resp.status !== 200){
          MySwal.fire({
            icon: "error",
            title: "Ocurrió un error al subir los datos",
            text: "Por favor inténtelo más tarde",
            showConfirmButton: true
          });
          return false;
        }
        
        const resp2 = await fetch("https://ymc-graph-api.azurewebsites.net/addnewparamresults", requestOptions2)
        if (resp2.status !== 200){
          MySwal.fire({
            icon: "error",
            title: "Ocurrió un error al subir los datos",
            text: "Por favor inténtelo más tarde",
            showConfirmButton: true
          });
          return false;
        }
    
        setTaskDone(true)
        setCalculated(true)
        setOneTime(true)
        MySwal.close();
      }
      catch(error){
        //console.log("there has been an error login in")
        MySwal.fire({
          icon: "error",
          title: "Ocurrió un error al subir los datos",
          text: "Por favor inténtelo más tarde",
          showConfirmButton: true
        });
        return false
      }
  }

    useEffect(() => {
      if(OneTime && document.getElementById("results")) {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
        setOneTime(false)
      }

      if(PageStart && decodedToken) {
        requestGetPatient()
        setPageStart(false)
      }
    },[OneTime, PageStart, Navigate, requestGetPatient, decodedToken]);

    function toggleAdditional2(id) {
      let tmp = document.getElementById(id)
      if(tmp.className.includes("UserWelcomeBlockPage1SpecificsHidden")) {
        tmp.className = tmp.className.replace(" UserWelcomeBlockPage1SpecificsHidden", "");
      } else {
        tmp.className += " UserWelcomeBlockPage1SpecificsHidden"
      }
    }

    const HandleFaces = useCallback(() => {
      if(window.innerWidth > 450 && PagewidthCorrection) {
          setPagewidthCorrection(false)
      } 
      if(window.innerWidth <= 450 && !PagewidthCorrection) {
          setPagewidthCorrection(true)
      } 
    },[PagewidthCorrection])

    useEffect(() => {
        window.addEventListener("resize", HandleFaces);
        return () => window.removeEventListener("resize", HandleFaces);
    }, [HandleFaces]);

    function toggleDescription(type,num="") {
        let tmp = document.getElementById("More"+num)
        let tmp2 = document.getElementById("Less"+num)
        if(type === "Less") {
            tmp.className += " HeartAgeCalculatorResultsRightSideWhatIfConsequenceHidden"
            tmp2.className = tmp2.className.replace(" HeartAgeCalculatorResultsRightSideWhatIfConsequenceHidden", "");
        } else {
            tmp.className = tmp.className.replace(" HeartAgeCalculatorResultsRightSideWhatIfConsequenceHidden", "");
            tmp2.className += " HeartAgeCalculatorResultsRightSideWhatIfConsequenceHidden"
        }
    }

    return (
        <div className='UserProfileFull'>
            <div className='UserProfileInnerDiv'>
                <div className='UserProfileInnerDivCalculatorWhiteBlock2'>
                  {!Calculated && TaskDone && FirstPage ?
                  <>
                  <div className='UserWelcomeBlockPageWideFlex'>
                    <div className='UserWelcomeBlockPageWideSideL'>
                      <div className='UserWelcomeBlockPage1TitleFlex'>
                          <div className='UserWelcomeBlockPage1Title'>Calcula tu riesgo de Síndrome Metabólico&ensp;</div>
                          <div className="UserWelcomeBlockPage1MoreInfo" onClick={() => toggleAdditional2("Added1")}>?</div>
                      </div>
                      <div className="UserWelcomeBlockPage1Specifics UserWelcomeBlockPage1SpecificsHidden" id="Added1">Este instrumento está indicado para personas con edades comprendidas entre 30 y 65 años, especialmente aquellas que puedan tener uno o varios factores de riesgo Triglivascular y no estén diagnosticados previamente de ninguna enfermedad Triglivascular, diabetes tipo II o diabetes tipo I con microalbuminuria.</div>
                      <img alt="" className='UserWelcomeBlockPage1TitleFoodImage' src="https://static.yomecontrolo.cl/public/img/calculator/MetabolicSyndromeSurveyImage.png" />
                      <div className='UserProfileInnerDivCalculatorWhiteBlockCompletionText'><span className='UserProfileInnerDivCalculatorWhiteBlockCompletionBigNumber'>1</span> de 2</div>
                      <div className='UserWelcomeIntroPageCounterLineStart'>
                        <div className='UserWelcomeIntroPageCounterLinePurple'></div>
                        <div className='UserWelcomeIntroPageCounterLine'></div>
                      </div>
                    </div>
                    <div className='UserWelcomeBlockPageWideSideR'>
                      <div className='UserProfileSindMetIconsFlex'>
                        <img alt="" className='UserProfileSindMetIcon' src="https://static.yomecontrolo.cl/public/icons/SkyBlueAbsPerimeterIcon.svg" />
                        <img alt="" className='UserProfileSindMetIcon' src="https://static.yomecontrolo.cl/public/icons/SkyBlueCardioHeartTrasparent.svg" />
                        <img alt="" className='UserProfileSindMetIcon' src="https://static.yomecontrolo.cl/public/icons/SkyBlueIndicatorIcon.svg" />
                        <img alt="" className='UserProfileSindMetIcon' src="https://static.yomecontrolo.cl/public/icons/SkyBlueCholesterol.svg" />
                        <img alt="" className='UserProfileSindMetIcon' src="https://static.yomecontrolo.cl/public/icons/SkyBlueRealHeartIcon.svg" />
                      </div>
                      <div className='UserWelcomeResultsCategories' style={{marginBlockEnd:"15px"}}>
                        <div className='UserWelcomeBlockResultsCategoriesSubtitle'>• <span style={{fontWeight:"700"}}>Obesidad abdominal:</span> Esto significa tener una circunferencia de cintura de más de 88 centímetros para las mujeres y de más de 102 pulgadas para los hombres. Un aumento de la circunferencia de la cintura es la forma de obesidad más fuertemente relacionada con el síndrome metabólico.</div>
                        <div className='UserWelcomeBlockResultsCategoriesSubtitle'>• <span style={{fontWeight:"700"}}>Presión arterial alta:</span> de 130/80 mm Hg (milímetros de mercurio) o más. La presión arterial normal se define como menos de 120 mm Hg para la presión sistólica (el número superior) y menos de 80 mm Hg para la presión diastólica (el número inferior).</div>
                        <div className='UserWelcomeBlockResultsCategoriesSubtitle'>• <span style={{fontWeight:"700"}}>Glicemia alterada en ayunas:</span> Esto significa un nivel igual o superior a 100 mg/dL.</div>
                        <div className='UserWelcomeBlockResultsCategoriesSubtitle'>• <span style={{fontWeight:"700"}}>Niveles elevados de triglicéridos:</span> Esto implica valores superiores a 150 mg/dL.</div>
                        <div className='UserWelcomeBlockResultsCategoriesSubtitle'>• <span style={{fontWeight:"700"}}>Colesterol HDL bajo:</span> Menos de 40 mg/dL para los hombres y menos de 50 mg/dL para las mujeres se consideran bajos.</div>
                      </div>
                    </div>
                  </div>
                  <div className="GeneralPurpleButtonFlex UserWelcomeBlockPageButton"  onClick={() => {setFirstPage(false); document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}} style={{marginInline:"auto"}}>
                    <div className="GeneralPurpleButtonText">Comenzar</div>
                    <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowWhite'></i></div>
                  </div>
                  </>
                  : !Calculated && TaskDone ?
                  <>
                  <div className='UserWelcomeBlockPageWideFlex'>
                    <div className='UserWelcomeBlockPageWideSideL'>
                      <div className='UserWelcomeBlockPage1TitleFlex'>
                          <div className='UserWelcomeBlockPage1Title'>Calcula tu riesgo de Síndrome Metabólico&ensp;</div>
                          <div className="UserWelcomeBlockPage1MoreInfo" onClick={() => toggleAdditional2("Added1")}>?</div>
                      </div>
                      <div className="UserWelcomeBlockPage1Specifics UserWelcomeBlockPage1SpecificsHidden" id="Added1">Este instrumento está indicado para personas con edades comprendidas entre 30 y 65 años, especialmente aquellas que puedan tener uno o varios factores de riesgo Triglivascular y no estén diagnosticados previamente de ninguna enfermedad Triglivascular, diabetes tipo II o diabetes tipo I con microalbuminuria.</div>
                      <img alt="" className='UserWelcomeBlockPage1TitleFoodImage' src="https://static.yomecontrolo.cl/public/img/calculator/MetabolicSyndromeSurveyImage.png" />
                      <div className='UserProfileInnerDivCalculatorWhiteBlockCompletionText'><span className='UserProfileInnerDivCalculatorWhiteBlockCompletionBigNumber'>1</span> de 2</div>
                      <div className='UserWelcomeIntroPageCounterLineStart'>
                        <div className='UserWelcomeIntroPageCounterLineBlue'></div>
                        <div className='UserWelcomeIntroPageCounterLinePurple'></div>
                      </div>
                    </div>
                    <div className='UserWelcomeBlockPageWideSideR'>
                      <div className="UserProfileHeartAgeCalculatorWhiteBlockTitle">Completa los datos faltantes para calcular tu riesgo de tener Síndrome Metabólico</div>
                      <div className="UserWelcomeBlockYNQuestion">Antecedentes precompletados</div>
                      <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompleted">
                        • Sexo al Nacer: {Gender === 1 ? "Hombre" : "Mujer"}<br/>
                        {PastAbs ?
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlex">
                          <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexLeft">• Perímetro Abdominal: {Abs} cm</div>
                          <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexRight" onClick={() => setPastAbs(false)}>Editar
                            <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleWritingIcon.svg" />
                          </div>
                        </div>
                        : null}
                        {PastTrigli ?
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlex">
                          <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexLeft">• Triglicéridos: {Trigli} mg/dL</div>
                          <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexRight" onClick={() => setPastTrigli(false)}>Editar
                            <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleWritingIcon.svg" />
                          </div>
                        </div>
                        : null}
                        {PastHDL ? 
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlex">
                          <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexLeft">• Colesterol HDL: {HDL} mg/dL</div>
                          <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexRight" onClick={() => setPastHDL(false)}>Editar
                            <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleWritingIcon.svg" />
                          </div>
                        </div>
                        : null}
                        {PastSystolic ? 
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlex">
                          <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexLeft">• Presión Sistólica: {Systolic} mmHg</div>
                          <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexRight" onClick={() => setPastSystolic(false)}>Editar
                            <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleWritingIcon.svg" />
                          </div>
                        </div>
                        : null}
                        {PastDiastolic ? 
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlex">
                          <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexLeft">• Presión Diastólica: {Diastolic} mmHg</div>
                          <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexRight" onClick={() => setPastDiastolic(false)}>Editar
                            <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleWritingIcon.svg" />
                          </div>
                        </div>
                        : null}
                        {PastGlucose ? 
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlex">
                          <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexLeft">• Glicemia (en ayunas): {Glucose} mg/dL</div>
                          <div className="UserProfileHeartAgeCalculatorWhiteBlockPrecompletedFlexRight" onClick={() => setPastGlucose(false)}>Editar
                            <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockRightButtonPlusIcon' src="https://static.yomecontrolo.cl/public/icons/PurpleWritingIcon.svg" />
                          </div>
                        </div>
                        : null}
                    </div>
                    <div className="UserProfileHeartAgeCalculatorWhiteBlockQuestionFlex">
                      {PastAbs ?
                        null
                        :
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockQuestion3">
                          <div className="HeartAgeCalculatorRightSideSurveyQ1Flex">
                              <div className="UserWelcomeBlockYNQuestion UserWelcomeBlockYNQuestionFullSize" style={{color: validation["Abs"] === "invalid" ? "red" : validation["Abs"] === "valid" ? "#8BC53F" : null}}>Indícanos tu perímetro abdominal</div>
                          </div>
                          <div className="HeartAgeCalculatorRightSideSurveyQ1MeasureFlex">
                              <input
                                  value={Abs}
                                  className="SignInInnerBoxInputTile"
                                  style={{ borderBottom: validation["Abs"] === "invalid" ? "red solid 1px" : validation["Abs"] === "valid" ? "#8BC53F solid 1px" : Abs.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Abs"] === "invalid" ? "#FFFAEA" : validation["Abs"] === "valid" || Abs.length === 0 ? "#FBFFFF" : "#F2F2FF" }}
                                  id="YMCAbs"
                                  onChange={(e) => handleChange(e.target.value,setAbs)}
                                  placeholder="Ingresa tu perímetro abdominal" />
                              <div className="HeartAgeCalculatorRightSideSurveyQ4InputMeasure">mg/dL</div>
                          </div>
                          <div className='UserProfileDiabetesWhiteBoxAbdominalPerimeterExplanation'>* Usa de referencia el punto medio entre la ultima costilla inferior hasta el hueso de la cadera.</div>
                          {validation["Abs"] === "invalid" ?
                              <div className='BloodAlert' style={{ color: "red", fontWeight: "500" }}> Input inválido o fuera de rango </div>
                          : null }
                        </div>
    }
                        {PastTrigli ?
                        null
                        :
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockQuestion3">
                          <div className="HeartAgeCalculatorRightSideSurveyQ1Flex">
                              <div className="UserWelcomeBlockYNQuestion UserWelcomeBlockYNQuestionFullSize" style={{color: validation["Trigli"] === "invalid" ? "red" : validation["Trigli"] === "valid" ? "#8BC53F" : null}}>Indícanos tu nivel de triglicéridos</div>
                          </div>
                          <div className="HeartAgeCalculatorRightSideSurveyQ1MeasureFlex">
                              <input
                                  value={Trigli}
                                  className="SignInInnerBoxInputTile"
                                  style={{ borderBottom: validation["Trigli"] === "invalid" ? "red solid 1px" : validation["Trigli"] === "valid" ? "#8BC53F solid 1px" : Trigli.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Trigli"] === "invalid" ? "#FFFAEA" : validation["Trigli"] === "valid" || Trigli.length === 0 ? "#FBFFFF" : "#F2F2FF" }}
                                  id="YMCTrigli"
                                  onChange={(e) => handleChange(e.target.value,setTrigli)}
                                  placeholder="Ingresa la cantidad" />
                              <div className="HeartAgeCalculatorRightSideSurveyQ4InputMeasure">mg/dL</div>
                          </div>
                          {validation["Trigli"] === "invalid" ?
                              <div className='BloodAlert' style={{ color: "red", fontWeight: "500" }}> Input inválido o fuera de rango </div>
                          : null }
                        </div>
    }
                        {PastHDL ?
                        null
                        :
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockQuestion3">
                          <div className="HeartAgeCalculatorRightSideSurveyQ1Flex">
                              <div className="UserWelcomeBlockYNQuestion UserWelcomeBlockYNQuestionFullSize" style={{color: validation["HDL"] === "invalid" ? "red" : validation["HDL"] === "valid" ? "#8BC53F" : null}}>Indícanos tus niveles de colesterol HDL</div>
                          </div>
                          <div className="HeartAgeCalculatorRightSideSurveyQ1MeasureFlex">
                              <input
                                  value={HDL}
                                  className="SignInInnerBoxInputTile"
                                  style={{ borderBottom: validation["HDL"] === "invalid" ? "red solid 1px" : validation["HDL"] === "valid" ? "#8BC53F solid 1px" : HDL.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["HDL"] === "invalid" ? "#FFFAEA" : validation["HDL"] === "valid" || HDL.length === 0 ? "#FBFFFF" : "#F2F2FF" }}
                                  id="YMCHDL"
                                  onChange={(e) => handleChange(e.target.value,setHDL)}
                                  placeholder="Ingresa la cantidad" />
                              <div className="HeartAgeCalculatorRightSideSurveyQ4InputMeasure">mg/dL</div>
                          </div>
                          {validation["HDL"] === "invalid" ?
                              <div className='BloodAlert' style={{ color: "red", fontWeight: "500" }}> Input inválido o fuera de rango </div>
                          : null }
                        </div>
    }
                        {PastSystolic ?
                        null
                        :
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockQuestion3">
                          <div className="HeartAgeCalculatorRightSideSurveyQ1Flex">
                              <div className="UserWelcomeBlockYNQuestion UserWelcomeBlockYNQuestionFullSize" style={{color: validation["Systolic"] === "invalid" ? "red" : validation["Systolic"] === "valid" ? "#8BC53F" : null}}>Indícanos tu presión arterial sistólica&ensp;</div>
                              <div className="UserWelcomeBlockPage1MoreInfo" onClick={() => toggleAdditional("PressureInfo")}>?</div>
                          </div>
                          <div className="HeartAgeCalculatorRightSideSurveyQ1SuggestionText InformationCollapsed" id="PressureInfo">Es la cifra superior (y más alta) en una medición de la presión arterial.</div>
                          <div className="HeartAgeCalculatorRightSideSurveyQ1MeasureFlex">
                              <input
                                  value={Systolic}
                                  className="SignInInnerBoxInputTile"
                                  style={{ borderBottom: validation["Systolic"] === "invalid" ? "red solid 1px" : validation["Systolic"] === "valid" ? "#8BC53F solid 1px" : Systolic.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Systolic"] === "invalid" ? "#FFFAEA" : validation["Systolic"] === "valid" || Systolic.length === 0 ? "#FBFFFF" : "#F2F2FF" }}
                                  id="YMCSystolic"
                                  onChange={(e) => handleChange(e.target.value,setSystolic)}
                                  placeholder="Ingresa tu presión sistólica" />
                              <div className="HeartAgeCalculatorRightSideSurveyQ4InputMeasure">mmHg</div>
                          </div>
                          {validation["Systolic"] === "invalid" ?
                              <div className='BloodAlert' style={{ color: "red", fontWeight: "500" }}> Input inválido o fuera de rango </div>
                          : null }
                        </div>
    }
                        {PastDiastolic ?
                        null
                        :
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockQuestion3">
                          <div className="HeartAgeCalculatorRightSideSurveyQ1Flex">
                              <div className="UserWelcomeBlockYNQuestion UserWelcomeBlockYNQuestionFullSize" style={{color: validation["Diastolic"] === "invalid" ? "red" : validation["Diastolic"] === "valid" ? "#8BC53F" : null}}>Indícanos tu presión arterial diastólica&ensp;</div>
                          </div>
                          <div className="HeartAgeCalculatorRightSideSurveyQ1MeasureFlex">
                              <input
                                  value={Diastolic}
                                  className="SignInInnerBoxInputTile"
                                  style={{ borderBottom: validation["Diastolic"] === "invalid" ? "red solid 1px" : validation["Diastolic"] === "valid" ? "#8BC53F solid 1px" : Diastolic.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Diastolic"] === "invalid" ? "#FFFAEA" : validation["Diastolic"] === "valid" || Diastolic.length === 0 ? "#FBFFFF" : "#F2F2FF" }}
                                  id="YMCDiastolic"
                                  onChange={(e) => handleChange(e.target.value,setDiastolic)}
                                  placeholder="Ingresa tu presión diastólica" />
                              <div className="HeartAgeCalculatorRightSideSurveyQ4InputMeasure">mmHg</div>
                          </div>
                          {validation["Diastolic"] === "invalid" ?
                              <div className='BloodAlert' style={{ color: "red", fontWeight: "500" }}> Input inválido o fuera de rango </div>
                          : null }
                        </div>
    }
                        {PastGlucose ?
                        null
                        :
                        <div className="UserProfileHeartAgeCalculatorWhiteBlockQuestion3">
                          <div className="HeartAgeCalculatorRightSideSurveyQ1Flex">
                              <div className="UserWelcomeBlockYNQuestion UserWelcomeBlockYNQuestionFullSize" style={{color: validation["Glucose"] === "invalid" ? "red" : validation["Glucose"] === "valid" ? "#8BC53F" : null}}>Indícanos tus niveles de glicemia en ayunas</div>
                          </div>
                          <div className="HeartAgeCalculatorRightSideSurveyQ1MeasureFlex">
                              <input
                                  value={Glucose}
                                  className="SignInInnerBoxInputTile"
                                  style={{ borderBottom: validation["Glucose"] === "invalid" ? "red solid 1px" : validation["Glucose"] === "valid" ? "#8BC53F solid 1px" : Glucose.length !== 0 ? "#330066 solid 1px" : "#BFD4E4 solid 1px", backgroundColor: validation["Glucose"] === "invalid" ? "#FFFAEA" : validation["Glucose"] === "valid" || Glucose.length === 0 ? "#FBFFFF" : "#F2F2FF" }}
                                  id="YMCGlucose"
                                  onChange={(e) => handleChange(e.target.value,setGlucose)}
                                  placeholder="Ingresa la cantidad" />
                              <div className="HeartAgeCalculatorRightSideSurveyQ4InputMeasure">mg/dL</div>
                          </div>
                          {validation["Glucose"] === "invalid" ?
                              <div className='BloodAlert' style={{ color: "red", fontWeight: "500" }}> Input inválido o fuera de rango </div>
                          : null }
                        </div>
    }
                      </div>
                    </div>
                  </div> 
                  <div className='UserWelcomeBlockNextButtonFlex'>
                    <div className="GeneralWhiteButtonFlex UserWelcomeBlockPageButton1" onClick={() => {setFirstPage(true); document.body.scrollTop = 0; document.documentElement.scrollTop = 0;}}>
                        <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowPurple' style={{rotate:"180deg"}}></i></div>
                        <div className="GeneralWhiteButtonText GeneralWhiteButtonTextPreviousText">Anterior</div>
                    </div>
                    <div className="GeneralPurpleButtonFlex UserWelcomeBlockPageButton" onClick={() => HandleSubmit()} style={{marginInline:"auto"}}>
                        <div className="GeneralPurpleButtonText">Calcular</div>
                        <div className='GeneralPurpleButtonIcon triangle'><i className='innerarrowWhite'></i></div>
                    </div>
                  </div>
                  </>
                  : Calculated ?
                  <>
                  <div id="results" className="HeartAgeCalculatorResultsTitleDiv UserProfileHeartAgeCalculatorWhiteBlockTitleDiv" style={{backgroundColor:"#CCCCFF"}}>
                    <div className="HeartAgeCalculatorRightSideTitleFlex">
                        <img alt="" className="HeartAgeCalculatorRightSideTitleIcon" src="https://static.yomecontrolo.cl/public/icons/HealthCalculatorPurpleLogo.png"/>
                        <div className="HeartAgeCalculatorRightSideTitleInnerDiv">
                            <div className="HeartAgeCalculatorRightSideUpTitle">Calculadora de Salud</div>
                            <div className="HeartAgeCalculatorRightSideTitle">Resultados</div>
                            <div className="HeartAgeCalculatorRightSideUpTitle">Síndrome Metabólico</div>
                        </div>
                    </div>
                    <img alt="" className="HeartAgeCalculatorResultsTitleYMCLogo" src="https://static.yomecontrolo.cl/public/icons/YMC_Logo_NoText.png"/>
                  </div>
                  <div className='UserWelcomeBlockPageWideFlex'>
                    <div className='UserWelcomeBlockPageWideSideL'>
                      <div className="UserProfileDiabetesWhiteBoxPart2">
                        <div className='HeartAgeCalculatorLeftSideResultHeartBlockInnerBlockFlex'>
                          <div className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedLeft' style={{backgroundColor: Risk["risk"] === 0 ? "rgba(139, 197, 63, 0.47)" : Risk["risk"] === 1 ? "rgba(255, 205, 41, 0.50)" : "rgba(255, 79, 83, 0.47)", marginInline:"auto", paddingBlock:"10px",width:"100%"}}>
                            <img alt="" className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedLeftImage' src="https://static.yomecontrolo.cl/public/img/calculator/MetabolicSyndromeSurveyImage.png" />
                          </div>
                          <div className='HeartAgeCalculatorLeftSideResultHeartBlockInnerBlock' style={{backgroundColor: Risk["risk"] === 0 ? "#8BC53F" : Risk["risk"] === 1 ? "#FFCD29" : "#FF4F53"}}>
                              <div className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedUpTitle' style={{color: "white"}}>Puntaje: {Risk["points"]} / 6</div>
                              <h5 className='UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedTitle' style={{color: "white"}}>
                                  <span style={{fontWeight:"700"}}>{Risk["riskCat"]}</span>
                              </h5>
                          </div>
                        </div>
                          {Risk["risk"] === 0 ?
                          <>
                          <div className="UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedMeter2" style={{backgroundImage:"url('https://static.yomecontrolo.cl/public/img/calculator/RiskMeterHorizontalSimplified.png')",backgroundPosition: 'center',backgroundSize: 'contain',backgroundRepeat: 'no-repeat'}}>
                              <img alt="" className="HeartAgeCalculatorLeftSideResultHeartBlockMeterFace" src="https://static.yomecontrolo.cl/public/img/calculator/RiskMeter_LowRiskFace.png" style={{left: "12px"}} />
                          </div>
                          <div className="UserProfileInnerDivCalculatorExplanationBlockBigText" id="More1" style={{marginBlockStart:"20px"}}>Con base en los antecedentes brindados, no cumple con los criterios diagnósticos de síndrome metabólico según los parámetros establecidos por el Ministerio de Salud (MINSAL) y organismos internacionales como la American Heart Association...
                        <br/><div className='UserProfileInnerDivCalculatorExplanationBlockBigTextOption' onClick={() => toggleDescription("Less",1)}>Ver más</div></div>
                        <div className="UserProfileInnerDivCalculatorExplanationBlockBigText HeartAgeCalculatorResultsRightSideWhatIfConsequenceHidden" id="Less1" style={{marginBlockStart:"20px"}}>Con base en los antecedentes brindados, no cumple con los criterios diagnósticos de síndrome metabólico según los parámetros establecidos por el Ministerio de Salud (MINSAL) y organismos internacionales como la American Heart Association. Aunque los factores de riesgo no están presentes o se encuentran dentro de los límites normales, es importante mantener un estilo de vida saludable para prevenir la aparición de alteraciones metabólicas en el futuro ya que esta enfermedad aumenta con la edad.
                        <br/><div className='UserProfileInnerDivCalculatorExplanationBlockBigTextOption' onClick={() => toggleDescription("More",1)}>Ver menos</div></div>
                          </>
                          : Risk["risk"] === 1 ?
                          <>
                          <div className="UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedMeter2" style={{backgroundImage:"url('https://static.yomecontrolo.cl/public/img/calculator/RiskMeterHorizontalSimplified.png')",backgroundPosition: 'center',backgroundSize: 'contain',backgroundRepeat: 'no-repeat'}}>
                              <img alt="" className="HeartAgeCalculatorLeftSideResultHeartBlockMeterFace" src="https://static.yomecontrolo.cl/public/img/calculator/RiskMeter_MidRiskFace.png" style={PagewidthCorrection === false ? {left: "36%", right: "64%"} : {left: "40%", right: "60%"}} />
                          </div>
                          <div className='UserWelcomeBlockResultsCategoriesSubtitle2' style={{marginBlockStart:"20px"}}>Con base en los antecedentes brindados, presenta alteraciones metabólicas que, aunque no cumplen con los criterios diagnósticos de síndrome metabólico, sugieren un riesgo aumentado de desarrollarlo en el futuro. Esta etapa representa una oportunidad para intervenir de manera efectiva y prevenir complicaciones mayores.</div>
                          </>
                          :
                          <>
                          <div className="UserProfileInnerDivCalculatorWhiteBlockSummaryBlockUnfoldedMeter2" style={{backgroundImage:"url('https://static.yomecontrolo.cl/public/img/calculator/RiskMeterHorizontalSimplified.png')",backgroundPosition: 'center',backgroundSize: 'contain',backgroundRepeat: 'no-repeat'}}>
                              <img alt="" className="HeartAgeCalculatorLeftSideResultHeartBlockMeterFace" src="https://static.yomecontrolo.cl/public/img/calculator/RiskMeter_HighRiskFace.png" style={{right: "12px"}}/>
                          </div>
                          <div className="UserProfileInnerDivCalculatorExplanationBlockBigText" id="More1" style={{marginBlockStart:"20px"}}>Con base en los antecedentes brindados, cumple con los criterios diagnósticos de síndrome metabólico establecidos por el Ministerio de Salud (MINSAL) y organismos internacionales como la American Heart Association...
                          <br/><div className='UserProfileInnerDivCalculatorExplanationBlockBigTextOption' onClick={() => toggleDescription("Less",1)}>Ver más</div></div>
                          <div className="UserProfileInnerDivCalculatorExplanationBlockBigText HeartAgeCalculatorResultsRightSideWhatIfConsequenceHidden" id="Less1" style={{marginBlockStart:"20px"}}>Con base en los antecedentes brindados, cumple con los criterios diagnósticos de síndrome metabólico establecidos por el Ministerio de Salud (MINSAL) y organismos internacionales como la American Heart Association, lo que implica un riesgo significativamente mayor de desarrollar enfermedades cardiovasculares y diabetes tipo 2. Este diagnóstico requiere un manejo integral y seguimiento médico continuo para reducir el impacto en la salud.
                          <br/><div className='UserProfileInnerDivCalculatorExplanationBlockBigTextOption' onClick={() => toggleDescription("More",1)}>Ver menos</div></div>
                          </>
      }
                        </div>
                      </div>
                      <div className='UserWelcomeBlockPageWideSideR'>
                        <div className="UserProfileDiabetesWhiteBoxPart2">
                          {Risk["risk"] === 0 ? 
                          <>
                          <div className='UserWelcomeResultsCategories'>
                              <h4 className='UserWelcomeBlockResultsCategoriesTitle'>Recomendaciones</h4>
                              <div className='UserWelcomeBlockResultsCategoriesSubtitle'>Mantener una dieta equilibrada basada en alimentos naturales, ricos en frutas, verduras, fibras y proteínas magras.
                              <br/>Realizar actividad física regularmente, al menos 150 minutos semanales de ejercicio aeróbico moderado.
                              <br/>Controlar el peso corporal y monitorear periódicamente parámetros como glucosa en sangre, perfil lipídico y presión arterial.</div>
                          </div>
                          </>
                          : Risk["risk"] === 1 ? 
                          <>
                          <div className='UserWelcomeResultsCategories'>
                              <h4 className='UserWelcomeBlockResultsCategoriesTitle'>Recomendaciones</h4>
                              <div className='UserWelcomeBlockResultsCategoriesTitle2'>Consulta médica:</div>
                              <div className='UserWelcomeBlockResultsCategoriesSubtitle'>Acudir a un profesional de la salud para evaluar alteración y control preventivo de poseer síndrome metabólico.</div>
                              <div className='UserWelcomeBlockResultsCategoriesTitle2'>Cambios en el estilo de vida:</div>
                              <div className='UserWelcomeBlockResultsCategoriesSubtitle'>Incorporar hábitos saludables, incluyendo una dieta baja en azúcares refinados y grasas saturadas, junto con una ingesta moderada de sal para controlar la presión arterial.</div>
                              <div className='UserWelcomeBlockResultsCategoriesTitle2'>Actividad física regular:</div>
                              <div className='UserWelcomeBlockResultsCategoriesSubtitle'>Incrementar la actividad física, priorizando ejercicios aeróbicos como caminar, trotar, nadar o andar en bicicleta.</div>
                              <div className='UserWelcomeBlockResultsCategoriesTitle2'>Control metabólico:</div>
                              <div className='UserWelcomeBlockResultsCategoriesSubtitle'>Realizar controles regulares de los niveles de glucosa, colesterol y presión arterial para monitorear el progreso de las intervenciones.</div>
                          </div>
                          </>
                          :
                          <>
                          <div className='UserWelcomeResultsCategories'>
                              <h4 className='UserWelcomeBlockResultsCategoriesTitle'>Recomendaciones</h4>
                              <div className='UserWelcomeBlockResultsCategoriesTitle2'>Atención médica especializada:</div>
                              <div className='UserWelcomeBlockResultsCategoriesSubtitle'>Consultar con un médico de familia o especialista en medicina interna  para diseñar un plan de tratamiento que puede incluir medicamentos para controlar la glucosa, presión arterial y lípidos.</div>
                              <div className='UserWelcomeBlockResultsCategoriesTitle2'>Cambios en el estilo de vida:</div>
                              <div className='UserWelcomeBlockResultsCategoriesSubtitle'>Adoptar una dieta controlada por un/a nutricionista, basada en alimentos ricos en fibra, bajos en grasas saturadas y con un adecuado índice glucémico.
                              <br/>Reducir la circunferencia abdominal mediante un programa de pérdida de peso sostenible, si aplica.</div>
                              <div className='UserWelcomeBlockResultsCategoriesTitle2'>Actividad física:</div>
                              <div className='UserWelcomeBlockResultsCategoriesSubtitle'>Realizar al menos 150-300 minutos de actividad física moderada-intensa a la semana, incluyendo ejercicios de resistencia para mejorar la sensibilidad a la insulina.</div>
                              <div className='UserWelcomeBlockResultsCategoriesTitle2'>Monitoreo y seguimiento:</div>
                              <div className='UserWelcomeBlockResultsCategoriesSubtitle'>Realizar controles médicos regulares para evaluar parámetros clave como presión arterial, perfil lipídico y niveles de glucosa.</div>
                              <div className='UserWelcomeBlockResultsCategoriesTitle2'>Apoyo psicológico:</div>
                              <div className='UserWelcomeBlockResultsCategoriesSubtitle'>Si existe estrés, ansiedad o dificultades para adherirse a los cambios, considerar apoyo psicológico para abordar factores emocionales que puedan influir en el manejo del síndrome metabólico.</div>
                          </div>
                          </> 
      }
                        </div>
                      </div>
                    </div>
                    <div className='UserWelcomeBlockPageWideFlex'>
                      <div className='GeneralWhiteButtonFlex UserWelcomeBlockPageButton2' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/perfil-de-usuario/calculadora-de-salud");}}>Terminar</div>
                      <div className='GeneralPurpleButtonFlex UserWelcomeBlockPageButton' onClick={() => {document.body.scrollTop = 0; document.documentElement.scrollTop = 0; Navigate("/plan-de-intervencion");}}>Ir a Recomendaciones</div>
                    </div>
                  </>
                  : null}
                </div>
            </div>
        </div>
    );
};

export default MetabolicSyndromeCalculator;